import type { Mission } from '../missions.ts'

export const mda: Mission = {
  id: "mda",
  name: "Missile Defense Agency",
  short: "MDA",
  call: "Missile Defense",
  kind: "subagency",
  parent: "dod",
  url: "https://www.mda.mil/",
  established: 2002,
  palette: {
    primary: "#145dab",
    secondary: "#000000",
    accent: "#ed1c24",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_the_U.S._Missile_Defense_Agency.svg",
  },
  motif: "orbit",
  mission: {
    text: "The Missile Defense Agency's (MDA) mission is to develop, deploy, and sustain layered and integrated missile defense capabilities as part of a comprehensive missile defeat approach to defend the United States, its deployed forces, allies, and friends from missile attacks in all phases of flight.",
    url: "https://www.mda.mil/about/mission.html",
  },
  fact: {
    text: "MDA's FTM-44 flight test in 2020 was the first intercept test for the SM-3 Block IIA interceptor against an ICBM-class target.",
    url: "https://www.mda.mil/about/history.html",
  },
  seal: {
    file: "public/seals/mda.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_U.S._Missile_Defense_Agency.svg",
  },
  identifier: {
    about: "https://www.mda.mil/about/about.html",
    accessibility: "https://dowcio.war.gov/508/",
    foia: "https://www.mda.mil/foia.html",
    noFear: "https://www.mda.mil/nofear.html",
    oig: "https://www.dodig.mil/",
    performance: "https://dam.defense.gov/Performance-Mgmt/",
    privacy: "https://www.mda.mil/privacy_office.html",
  },
  media: {
    photos: [
      {
        file: "/media/mda-gbi-launch.jpg",
        small: "/media/mda-gbi-launch-sm.jpg",
        alt: "A Ground-based Interceptor rises from its silo on a column of flame and white smoke above green coastal hills under a blue sky.",
        title: "Ground-based Midcourse Defense interceptor launch, Vandenberg Air Force Base, California, March 25, 2019",
        creator: "Jose Davila, U.S. Space Force",
        source: "https://commons.wikimedia.org/wiki/File:TEST_OF_NATION'S_MIDCOURSE_DEFENSE_SYSTEM_CONDUCTED_(5210378).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/mda-lrdr-alaska.jpg",
        small: "/media/mda-lrdr-alaska-sm.jpg",
        alt: "The Long Range Discrimination Radar, a massive angular building with two large flat radar faces, stands in snow under a dusky winter sky.",
        title: "Long Range Discrimination Radar, Clear Space Force Station, Alaska, December 9, 2021",
        creator: "U.S. Space Command",
        source: "https://commons.wikimedia.org/wiki/File:211026-D-D0500-101.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
